import { host } from '../script/variables';

/* ================================================================
   Plan guard (partner dashboard)
   The backend answers plan-restricted requests with a JSON `code`
   (PLAN_REQUIRED, PLAN_READ_ONLY, PLAN_FEATURE_UNAVAILABLE,
   PLAN_LIMIT_REACHED, PLAN_QUOTA_EXHAUSTED, NOT_YOUR_RESTAURANT).
   Instead of handling that in every component, one fetch wrapper
   broadcasts a window event that <PlanBlockedDialog/> shows.
================================================================ */

export const PLAN_BLOCKED_EVENT = 'rp:plan-blocked';
export const OPEN_PLANS_EVENT = 'rp:open-plans';
export const PLAN_CHANGED_EVENT = 'rp:plan-changed';

const HANDLED = new Set([
  'PLAN_REQUIRED', 'PLAN_READ_ONLY', 'PLAN_FEATURE_UNAVAILABLE',
  'PLAN_LIMIT_REACHED', 'PLAN_QUOTA_EXHAUSTED', 'NOT_YOUR_RESTAURANT',
]);

let installed = false;

/** Wraps window.fetch once; safe to call from several components. */
export function installPlanInterceptor() {
  if (installed || typeof window === 'undefined' || !window.fetch) return;
  installed = true;
  const original = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const res = await original(...args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      if ((res.status === 402 || res.status === 403) && url.startsWith(host)) {
        res.clone().json().then((body) => {
          if (body && HANDLED.has(body.code)) {
            window.dispatchEvent(new CustomEvent(PLAN_BLOCKED_EVENT, { detail: body }));
          }
        }).catch(() => {});
      }
    } catch { /* never interfere with the caller */ }
    return res;
  };
}

/** Opens Settings → Plans & Billing (from any partner page). */
export function openPlans() {
  if (window.location.pathname === '/partner') {
    window.dispatchEvent(new CustomEvent(OPEN_PLANS_EVENT));
  } else {
    window.location.assign('/partner?open=plans');
  }
}

export async function fetchEntitlements(cafeId) {
  const token = localStorage.getItem('partnertoken');
  if (!token) return null;
  const qs = cafeId ? `?cafeId=${encodeURIComponent(cafeId)}` : '';
  const res = await fetch(`${host}/partner/plans/entitlements${qs}`, { headers: { Authorization: token } });
  if (!res.ok) return null;
  return res.json();
}
